import React from "react";
import CommonInputSenha from "../../../components/forms/CommonInputSenha";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import {
  handleChange,
  handleChangeFile,
} from "../../../helpers/handleFormChanges";
import CommonSwal from "../../../components/Swal/commonSwal";
import PropTypes from "prop-types";

function ChaveIntegracao({ valuesHook }) {
  const { values, setValues } = valuesHook;

  const validaDocumento = (e, type) => {
    const file = e.target.files ? e.target.files[0] : "";
    var allowedExtensions;

    if (type === "key") allowedExtensions = /(\.key)$/i;
    else if (type === "crt") allowedExtensions = /(\.crt)$/i;

    if (!allowedExtensions.exec(file && file.name)) {
      return true;
    }

    return false;
  };

  return (
    <>
      <form autoComplete="off">
        <h5 className="card-title my-3">Chave de integração (Banco Inter)</h5>
        <div className="row">
          <div className="col-6 mb-3">
            <CommonInputSenha
              label={
                values && values?.client_id_sent ? (
                  <>
                    Client_id
                    <span className="ms-2 badge bg-success">Enviado</span>
                  </>
                ) : (
                  "Client_id"
                )
              }
              id="client_id"
              value={values.client_id}
              onChange={(e) => handleChange(e, values, setValues)}
              autocomplete={false}
            />
          </div>
          <div className="col-6 mb-3">
            <CommonInputSenha
              label={
                values && values?.client_secret_sent ? (
                  <>
                    Client_secret
                    <span className="ms-2 badge bg-success">Enviado</span>
                  </>
                ) : (
                  "Client_secret"
                )
              }
              id="client_secret"
              value={values.client_secret}
              onChange={(e) => handleChange(e, values, setValues)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3">
            <CommonInputFile
              label={
                values && values?.arquivo_crt_sent ? (
                  <>
                    Arquivo crt
                    <span className="ms-2 badge bg-success">Enviado</span>
                  </>
                ) : (
                  "Arquivo crt"
                )
              }
              id="arquivo_crt"
              onChange={(e) => {
                validaDocumento(e, "crt")
                  ? CommonSwal({
                      title: "Arquivo inválido.",
                      icon: "error",
                    }).then(() => {
                      e.target.value = "";
                    })
                  : handleChangeFile(e, values, setValues);
              }}
              accept=".crt"
            />
          </div>
          <div className="col-md-6 mb-3">
            <CommonInputFile
              label={
                values && values?.arquivo_crt_sent ? (
                  <>
                    Arquivo key
                    <span className="ms-2 badge bg-success">Enviado</span>
                  </>
                ) : (
                  "Arquivo key"
                )
              }
              id="arquivo_key"
              onChange={(e) => {
                validaDocumento(e, "key")
                  ? CommonSwal({
                      title: "Arquivo inválido.",
                      icon: "error",
                    }).then(() => {
                      e.target.value = "";
                    })
                  : handleChangeFile(e, values, setValues);
              }}
              accept=".key"
            />
          </div>
          {/* <div className="col-md-4 mb-3">
          <CommonInputDate
            label="Validade"
            id="crt_validade"
            value={values.crt_validade}
            disabled={true}
            onChange={(e) => handleChange(e, values, setValues)}
          />
        </div> */}
        </div>
      </form>
    </>
  );
}

ChaveIntegracao.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
};

export default ChaveIntegracao;
